import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Materials_ds_get_materials_by_gtinService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { gtin: string, projectId?: number }): 
  Promise<{ result: { Id?: number, ControllerTypeId?: number, LookupCode?: string, ProjectId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.gtin)) {
      missingRequiredInParams.push('\'gtin\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Materials/datasources/ds_get_materials_by_gtin/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { gtin: string, projectId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ControllerTypeId?: number, LookupCode?: string, ProjectId?: number }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.gtin)) {
      missingRequiredInParams.push('\'gtin\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Materials/datasources/ds_get_materials_by_gtin/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { gtin: string, projectId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ControllerTypeId?: number, LookupCode?: string, ProjectId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.gtin)) {
      missingRequiredInParams.push('\'gtin\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Materials/datasources/ds_get_materials_by_gtin/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
